var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('radialGradient', {
    attrs: {
      "cx": "1.81949774%",
      "cy": "90.8445653%",
      "fx": "1.81949774%",
      "fy": "90.8445653%",
      "r": "144.576101%",
      "id": "radialGradient-1"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FED576",
      "offset": "0%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#F47133",
      "offset": "26.34%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#BC3081",
      "offset": "60.91%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#4C63D2",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "cx": "1.81367144%",
      "cy": "90.830228%",
      "fx": "1.81367144%",
      "fy": "90.830228%",
      "r": "144.603931%",
      "gradientTransform": "translate(0.018137,0.908302),scale(1.000000,0.999797),rotate(-3.000698),translate(-0.018137,-0.908302)",
      "id": "radialGradient-2"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FED576",
      "offset": "0%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#F47133",
      "offset": "26.34%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#BC3081",
      "offset": "60.91%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#4C63D2",
      "offset": "100%"
    }
  })], 1)], 1), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Web/*_Assets/Icons/ic_instagram/Light-Mode",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Instagram",
      "transform": "translate(3.000000, 3.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.76097561,0.419597479 C2.23414634,0.624517178 1.78861789,0.897743444 1.34308943,1.34336247 C0.897560976,1.78572881 0.624390244,2.23460053 0.419512195,2.7582842 C0.221138211,3.26570441 0.087804878,3.84793657 0.0487804878,4.70014231 C0.00975609756,5.55234804 0,5.8255743 0,7.99837365 C0,10.171173 0.00975609756,10.4443993 0.0487804878,11.296605 C0.087804878,12.1488107 0.224390244,12.7310429 0.419512195,13.2384631 C0.624390244,13.7653995 0.897560976,14.2110185 1.34308943,14.6566375 C1.78861789,15.1022566 2.23414634,15.3754828 2.76097561,15.5804025 C3.26829268,15.7788168 3.8504065,15.9121773 4.70243902,15.9512096 C5.55447154,15.9902419 5.82764228,16 8,16 C10.1723577,16 10.4455285,15.9902419 11.297561,15.9512096 C12.1495935,15.9121773 12.7317073,15.7755641 13.2390244,15.5804025 C13.7658537,15.3754828 14.2113821,15.1022566 14.6569106,14.6566375 C15.102439,14.2110185 15.3756098,13.7653995 15.5804878,13.2384631 C15.7788618,12.7310429 15.9121951,12.1488107 15.9512195,11.296605 C15.9902439,10.4443993 16,10.171173 16,7.99837365 C16,5.8255743 15.9902439,5.55234804 15.9512195,4.70014231 C15.9121951,3.84793657 15.7756098,3.26570441 15.5804878,2.7582842 C15.3756098,2.23460053 15.102439,1.78572881 14.6601626,1.34336247 C14.2146341,0.897743444 13.7691057,0.624517178 13.2422764,0.419597479 C12.7349593,0.221183167 12.1528455,0.0878227282 11.300813,0.0487904046 C10.4487805,0.00975808091 10.1756098,0 8.00325203,0 C5.83089431,0 5.55772358,0.00975808091 4.70569106,0.0487904046 C3.8504065,0.0845700346 3.26829268,0.221183167 2.76097561,0.419597479 Z M11.2325203,1.48648099 C12.0130081,1.52226062 12.4357724,1.65236837 12.7186992,1.76295995 C13.0926829,1.90933116 13.3593496,2.08172393 13.6390244,2.36145558 C13.9186992,2.64118723 14.0910569,2.90790811 14.2373984,3.28196788 C14.3479675,3.56495223 14.4780488,3.9878024 14.5138211,4.76844887 C14.5528455,5.61089652 14.5593496,5.86460663 14.5593496,8.00162635 C14.5593496,10.1386461 14.5495935,10.3923562 14.5138211,11.2348038 C14.4780488,12.0154503 14.3479675,12.4383005 14.2373984,12.7212848 C14.0910569,13.0953446 13.9186992,13.3620655 13.6390244,13.6417971 C13.3593496,13.9215288 13.0926829,14.0939215 12.7186992,14.2402927 C12.4357724,14.3508843 12.0130081,14.4809921 11.2325203,14.5167717 C10.3902439,14.555804 10.1365854,14.5623094 8,14.5623094 C5.86341463,14.5623094 5.6097561,14.5525513 4.76747967,14.5167717 C3.98699187,14.4809921 3.56422764,14.3508843 3.28130081,14.2402927 C2.90731707,14.0939215 2.64065041,13.9215288 2.36097561,13.6417971 C2.08130081,13.3620655 1.90894309,13.0953446 1.76260163,12.7212848 C1.65203252,12.4383005 1.52195122,12.0154503 1.48617886,11.2348038 C1.44715447,10.3923562 1.44065041,10.1386461 1.44065041,8.00162635 C1.44065041,5.86460663 1.4504065,5.61089652 1.48617886,4.76844887 C1.52195122,3.9878024 1.65203252,3.56495223 1.76260163,3.28196788 C1.90894309,2.90790811 2.08130081,2.64118723 2.36097561,2.36145558 C2.64065041,2.08172393 2.90731707,1.90933116 3.28130081,1.76295995 C3.56422764,1.65236837 3.98699187,1.52226062 4.76747967,1.48648099 C5.6097561,1.44744867 5.86341463,1.44094328 8,1.44094328 C10.1365854,1.44094328 10.3902439,1.44744867 11.2325203,1.48648099 Z",
      "id": "Shape",
      "fill": "url(#radialGradient-1)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.89268293,8.00162635 C3.89268293,10.2720065 5.73333333,12.1097784 8,12.1097784 C10.2666667,12.1097784 12.1073171,10.2687538 12.1073171,8.00162635 C12.1073171,5.73449888 10.2699187,3.89347428 8,3.89347428 C5.7300813,3.89347428 3.89268293,5.73124619 3.89268293,8.00162635 Z M10.6666667,8.00162635 C10.6666667,9.47509656 9.47317073,10.6688351 8,10.6688351 C6.52682927,10.6688351 5.33333333,9.47509656 5.33333333,8.00162635 C5.33333333,6.52815613 6.52682927,5.33441756 8,5.33441756 C9.47317073,5.33441756 10.6666667,6.52815613 10.6666667,8.00162635 Z",
      "id": "Shape",
      "fill": "url(#radialGradient-2)"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "Oval",
      "fill": "#654C9F",
      "cx": "12.2731707",
      "cy": "3.7308396",
      "rx": "1",
      "ry": "1"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }